import * as firebase from "firebase/app";
import "firebase/auth";
//import "firebase/firestore";

// firebase init - add your own config here
const firebaseConfig = {
  apiKey: "AIzaSyCS61snNCTkIyqufDoXoXiYQQv5rGkopD0",
  authDomain: "destpay-fdbe4.firebaseapp.com",
  projectId: "destpay-fdbe4",
  storageBucket: "destpay-fdbe4.appspot.com",
  messagingSenderId: "643960461613",
  appId: "1:643960461613:web:3fc0baa8510b511f6a9ba4",
  measurementId: "G-1RNWMG9B28"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// utils
//const db = firebase.firestore();
const auth = firebase.auth();
/*
// collection references
const usersCollection = db.collection("users");
const postsCollection = db.collection("posts");
const commentsCollection = db.collection("comments");
const likesCollection = db.collection("likes");

*/
// export utils/refs
export { auth, firebase }; // db, usersCollection, postsCollection, commentsCollection, likesCollection
